const selectors = {
    productContainer: document.querySelector('.product-details-wrapper'),
    reviewratingEle: document.querySelector('.product-details-wrapper [data-hulkapps-reviews]'),
    productMedia: document.querySelector('[data-productMedia]'),
    productJson: document.querySelector('[data-product-json]'),
    zoomBtns: document.querySelectorAll('[data-productZoom]')
  };

var hasShiftJson = null,
    hasRangeJson = null,
    mainProd = null,
    hasAccJson = [],
    hasAccName = [];

  const mediaJSON = JSON.parse(selectors.productMedia.innerHTML);
  mainProd = document.querySelector('[data-template="electric-bike"]') != null ? JSON.parse(selectors.productJson.innerHTML) : null;
  window.productMedia = mediaJSON;

  class ProductDrawer extends HTMLElement {
    constructor() {
      super();
      this.touchstartX = 0;
      this.touchendX = 0;
      this.isOpen =  this.classList.contains('opened-drawer');
      this.drawerBody = document.querySelector('#drawer-product');
      this.openeBy = document.querySelectorAll('#product-drawer-btn');      
      this.availMetrixJson = document.querySelector('[data-product-metrix]') != null ? JSON.parse(document.querySelector('[data-product-metrix]').innerHTML) : null;      
      if(document.querySelector('[data-template="electric-bike"]') != null && this.drawerBody.innerHTML.length == 0){        
        this.getDrawerData();
        this.onVariantChange('load');
        this.bindEvents();
      }
      
    }

    getAccInput(event){
        if(event){
            let a = this.accJson.find(x => x.id == event.target.value);
            // let v = a.variants.find(x => x.option1 == this.currentVariant.option1) || a.variants[0];
            let v = a;
            v.product_id = a.id;
            v.product_title = a.product_title;
            if(event.target.checked){
                hasAccJson.push(v);
                hasAccName.push(event.target.getAttribute('data-product-title'));
            } else {
                const index = hasAccJson.indexOf(v);
                if (index > -1) {
                    hasAccJson.splice(index, 1);
                    hasAccName.splice(index, 1);
                }
            }
        } else {
            let a = document.querySelector('product-drawer [data-free-input]') ? document.querySelector('product-drawer [data-free-input]').value : null;            
            if(a != null){
                hasAccName.push(document.querySelector('product-drawer [data-free-input]') ? document.querySelector('product-drawer [data-free-input]').getAttribute('data-product-title') : '-')
                hasAccJson.push(a);
            }
        }

        this.renderProductInfo();
    }

    getRangeInput(event){
        hasRangeJson = event.target.checked ? JSON.parse(document.querySelector('product-drawer [data-rangeJSON]').textContent) : null;
        this.renderProductInfo();
    }
    
    upgradeShiftFunc(event){
        let options = hasShiftJson != null ? hasShiftJson.options : this.currentVariant.options;
        options[2] = document.querySelector('product-drawer [data-upgrade-wheel]').checked ? document.querySelector('product-drawer [data-upgrade-wheel]').value : document.querySelector('product-drawer [data-wheel-wrap] [data-upgrade-wheel-opt]').value;
        if(event.target.checked && this.shiftJson != null){
            hasShiftJson = this.shiftJson.find(element => element.title == this.currentVariant.title);                    
        } else {
            hasShiftJson = null;
        }

        this.getVariant(options);
        if(this.currentVariant){ this.toggleAddButton('enable'); }
        this.renderProductInfo();
    }

    upgradeWheelFunc(event){
        let options = this.currentVariant.options;
        options[2] = event.target.checked ? event.target.value : document.querySelector('product-drawer [data-wheel-wrap] [data-upgrade-wheel-opt]').value;        
        this.getVariant(options);        
        this.renderProductInfo();
        if(this.currentVariant){ this.toggleAddButton('enable'); }
    }

    getVariant(options){
        let variantsArray = hasShiftJson != null ? JSON.parse(document.querySelector('[data-upgrade-shift-json]').textContent) : JSON.parse(this.variant_json.textContent);        
        variantsArray.find((variant) => {
            let mappedValues = variant.options.map((option, index) => {
                return options[index] === option;
            });
            if(!mappedValues.includes(false)){
                this.currentVariant = variant;
                return;
            }
        });
      
    }
  
    onKeyUp(event) {
      if(event.code.toUpperCase() !== 'ESCAPE') return;
    }
  
    bindEvents() {        
        if(document.querySelector('[data-template="electric-bike"]') != null) { 
            this.openeBy.forEach(option => option.addEventListener('click', this.openProductDrawer.bind(this)));
            this.onVariantChange('load');
            this.getAccInput();
        }
        this.addEventListener('keyup', this.onKeyUp.bind(this));
    }

    getDrawerData(){    
        this.drawerBody.innerHTML = document.querySelector('[data-product-drawer-content]').innerHTML;
        this.form = document.querySelector('[data-product-drawer-content] form');        
        this.variant_json = this.form.querySelector('[data-variantJSON]');
        this.addBtn = document.querySelector('product-drawer [name="add"]') || null;
        this.addBtn.addEventListener('click', this.onSubmitHandler.bind(this));                
        this.shiftJson = document.querySelector('[data-upgrade-shift-json]') != null ? JSON.parse(document.querySelector('[data-upgrade-shift-json]').textContent) : null;
        this.accJson = [];
        if(document.querySelectorAll('product-drawer [data-acc-json]') != null){            
            document.querySelectorAll('product-drawer [data-acc-json]').forEach((x) => {                
                this.accJson.push(JSON.parse(x.textContent));
            });            
        };        
        document.querySelector('product-drawer [data-upgrade-wheel]').addEventListener('change', this.upgradeWheelFunc.bind(this));        
        document.querySelector('product-drawer [data-range-input]').addEventListener('change', this.getRangeInput.bind(this));
        document.querySelectorAll('product-drawer [data-acc-input]').forEach(option => option.addEventListener('change', this.getAccInput.bind(this)));
        document.querySelectorAll('[data-single-option-selector]').forEach(option => option.addEventListener('change', this.onVariantChange.bind(this)));
        document.querySelectorAll('[data-cust-opts]').forEach(option => option.addEventListener('click', this.triggerVariantChange.bind(this)));

        if(document.querySelector('[data-upgrade-shift-json]') != null){
            document.querySelector('product-drawer [data-upgrade-shift]').addEventListener('change', this.upgradeShiftFunc.bind(this));
        }
        this.addBtn = document.querySelector('product-drawer [name="add"]');        
    }

    triggerVariantChange(evt){
        const e = new Event("change");
        const element = this.drawerBody.querySelector(`#${evt.target.getAttribute('data-swatch-id')}`);        
        element.checked = true;
        element.dispatchEvent(e);        
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const addItems = [];
      const random = Math.random();

      const properties = {
        _type: 'prod-main',
        _default_us: this.currentVariant.product_id
      };

      const country = document.querySelector('#CountryListBtn').getAttribute('data-value') || 'US';

      this.addBtn.setAttribute('disabled', true);
      this.addBtn.classList.add('loading');

      let mainProd = this.currentVariant.id;
      
      if(hasRangeJson != null){
        let rangeId = hasRangeJson.id;            

        properties._rangeExtender = rangeId;
        properties._random = random;
        addItems.push({
          id: rangeId,
          quantity: 1,
          title: this.currentVariant.title,
          properties: {
            _type: 'range_ex',
            _parent_id: mainProd,
            _random: random,
            _default_us: hasRangeJson.product_id
          }
        });
      }

      if(hasAccJson.length > 0){
        properties._accessories = hasAccName.join();
        let aJ = [];
        hasAccJson.forEach((x) => {
          let accId = x.variant.id;

          aJ.push(accId);
          addItems.push({
            id: accId,
            quantity: 1,
            title: this.currentVariant.title,
            properties: {
              _type: 'acc',
              _parent_id: mainProd,
              _random: random,
              _default_us: x.product_id
            }
          });
        });    
        properties._accessoriesIds = aJ.join();        
      }

      addItems.push({
        id: mainProd,
        quantity: 1,
        properties: properties
      });

      let dataAddItems = addItems;

      const body = JSON.stringify({
        items: dataAddItems
      });
      fetch(`${routes.cart_add_url}`, { ...fetchConfig(), body })
      .then((response) => response.json())
      .then((parsedState) => {
        if(parsedState.errors == undefined){
          evt.target.classList.remove('loading');
          evt.target.removeAttribute('disabled');
          window.location.href = `${Shopify.routes.root}cart`;
        }
      })
      .catch((e) => {        
        console.error(e);
      });
    }

    toggleAddButton(status) {        
        if (!this.addBtn) return;
        this.addBtn.classList.remove('soldout');
        if (status == 'disable') {
          this.addBtn.setAttribute('disabled', true);
          if(this.addBtn.querySelector('.add-text'))
            this.addBtn.querySelector('.add-text').textContent = window.variantStrings.unavailable;
            this.addBtn.classList.add('soldout');
        } else if(this.currentVariant && !this.currentVariant.available) {
          this.addBtn.setAttribute('disabled', true);
          if(this.addBtn.querySelector('.add-text'))
            this.addBtn.querySelector('.add-text').textContent = window.variantStrings.soldOut;
            this.addBtn.classList.add('soldout');
        } else {
          this.addBtn.removeAttribute('disabled');
          this.addBtn.querySelector('.add-text').innerHTML = window.variantStrings.addToCart;
          
        };
    }

    updateURLandID(currentVariant) {
        if (!currentVariant) return;

        // update query string with latest variant ID
        if(this.formType == 'product-page') window.history.replaceState({ }, '', `${this.dataset.url}?variant=${currentVariant.id}`);
    
        // update variant input with currentVariant Id
        const input = this.form.querySelector('input[name="id"]');
        input.value = currentVariant.id;
    }

    onVariantChange(event) {
        this.setCurrentVariant();
        if(this.formType == 'product-page') window.globalVariables.product.currentVariant = this.currentVariant;
        if (!this.currentVariant) {
          this.toggleAddButton('disable');
          let options = this.form.querySelectorAll('[data-optionindex]');
          options.forEach(option => {
            let lableID = 'option'+option.dataset.optionindex;
            const selectedValue = option.querySelector('input[type="radio"]:checked');
            const lable = option.querySelector('.selected-option');
            if(!lable || !lableID || !selectedValue) return;
            lable.innerHTML = selectedValue.value;
          });
        } else {         
            if(event){
                if(event != 'load'){
                    document.querySelectorAll(`body [data-swatch-id]`).forEach(option => option.classList.remove('active'));
                }
            
                let currentTarget = event.target || document.querySelector('product-drawer .color-swatch input:checked');
                let currentTargetSize = document.querySelector('product-drawer .size-drawer-input input:checked');
                let targetName = currentTarget.getAttribute('name') || '';
                document.querySelectorAll(`body [data-swatch-id="${currentTarget.getAttribute('id')}"]`).forEach(option => option.classList.add('active'));
                if(targetName == 'color'){
                    let hex = currentTarget.getAttribute('data-color');    
                    let hex_name = currentTarget.getAttribute('value').replaceAll(' ', '-').toLowerCase();                    
                    document.querySelector('product-drawer [data-color-name]').textContent = currentTarget.value;
                    document.querySelector('body').classList.add = hex_name;
                    document.querySelector('body').setAttribute('data-bg-body', `color-${hex_name}`)
                    document.querySelectorAll('[data-bg-apply]').forEach(option => {                        
                        option.style.background = hex;
                    });
                    
                    // if(hasAccJson.length > 0){
                    //     document.querySelectorAll('product-drawer [data-acc-input]:checked').forEach((element) => {                            
                    //         let a = this.accJson.find(x => x.id == element.value);
                    //         let v = a.variants.find(x => x.option1 == this.currentVariant.option1);                            
                    //         v.product_id = a.id;
                    //         v.product_title = a.product_title;
                    //         const index = hasAccJson.findIndex(object => {
                    //         return object.product_id == element.value;
                    //         });
                    //         if (index > -1) {
                    //             hasAccJson.splice(index, 1);
                    //         }
                    //         hasAccJson.push(v);
                    //     })
                    // }
                } 

                if(currentTargetSize.getAttribute('name') == 'size'){
                    document.querySelector('body [data-height]').innerHTML = 'Height: ' + document.querySelector(`product-drawer #${currentTargetSize.getAttribute('id')}`).getAttribute('data-height-text');
                  document.querySelector('body [data-standover-height]').innerHTML = 'Standover height: ' + document.querySelector(`product-drawer #${currentTargetSize.getAttribute('id')}`).getAttribute('data-standover-text');
                }                
                
            }    
            this.renderProductInfo();
          
          this.updateURLandID(this.currentVariant);
          this.toggleAddButton('enable');
        }
      }

    setCurrentVariant() {
        this.currentVariant = false;
        let options = this._getOptionsFromRadio();

        let variantsArray = this._getVariantData();
        variantsArray.find((variant) => {
            let mappedValues = variant.options.map((option, index) => {
                return options[index] === option;
            });
            if(!mappedValues.includes(false)){
                this.currentVariant = variant;
                return;
            }
        });
    }

    _getOptionsFromRadio() {
    const fieldsets = Array.from(document.querySelectorAll('product-drawer [data-single-option-selector]:checked'));
    const options = fieldsets.map((radio) => radio.value);        
    return options;
    }
  
    _getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.variant_json.textContent);
        return this.variantData;
    }

    renderProductInfo() {
        let priceCount = this.currentVariant.price;
        if(hasRangeJson != null){
            priceCount += parseInt(this.form.querySelector('[data-variant-id="'+hasRangeJson.id+'"]').getAttribute('data-price'));
        }

        if(hasAccJson.length > 0){
            hasAccJson.forEach(element => {
                priceCount += element.variant.price; 
            });            
        }
       
        document.querySelector('[data-variant-price]').innerHTML = Shopify.formatMoney(this.currentVariant.price, window.globalVariables.money_format);        
        document.querySelectorAll('[data-variant-opt1]').forEach(opt => opt.innerText = this.currentVariant.option1);

        if(this.drawerBody.innerHTML.length != 0){        
            this.drawerBody.querySelector('[data-drawer-total]').textContent = Shopify.formatMoney(priceCount, window.globalVariables.money_format);
            this.drawerBody.querySelector('[data-acc-opts]').textContent = hasAccName.join(', ');         
            let size = this.currentVariant.option2.includes('- ships') ? this.currentVariant.option2.split('- ships') : this.currentVariant.option2;   
            this.drawerBody.querySelector('[data-variant-opt2]').textContent = size[0];
            this.drawerBody.querySelector('[data-variant-opt3]').textContent = this.currentVariant.option3;
            this.drawerBody.querySelector('[data-product-opt]').textContent = hasShiftJson != null ? 'Di2' : 'GRX';            
             if(this.currentVariant.featured_image != null) this.drawerBody.querySelector('[data-variant-img]').setAttribute('src', this.currentVariant.featured_image);

        }

        document.querySelector('product-drawer [data-matrix-note]').classList.add('d-none');

        if(this.availMetrixJson != null && this.currentVariant.available == true){            
            let n =  this.availMetrixJson.find(x => x.option1 == this.currentVariant.option1 && x.option2 == this.currentVariant.option2);
            if(n != undefined){
                document.querySelector('product-drawer [data-matrix-note]').innerHTML = `<small>${n.note}</small>`;
                document.querySelector('product-drawer [data-matrix-note]').classList.remove('d-none');
            }
        }
        
    }

    /**
     * Open Menu Drawer
     *
     * @param {event} Event instance
     */
     openProductDrawer(event) {        
        this.classList.add('opened-drawer');
        this.renderProductInfo();
        siteOverlay.prototype.showOverlay();
        Utility.forceFocus(this.querySelector('[data-p-title]'));
        
        if(event){
          event.preventDefault();
          let openBy = event.currentTarget;
          openBy.setAttribute('aria-expanded', true);          
        }
    }
  
    /**
     * Close Menu Drawer
     *
     * @param {event} Event instance
     */
    closeProductDrawer(event, elementToFocus = false) {
      if (event !== undefined) {
        event.preventDefault();
        this.classList.remove('opened-drawer');
        siteOverlay.prototype.hideOverlay();
        this.openeBy.forEach(option => option.setAttribute('aria-expanded', false));
        Utility.forceFocus(this.openeBy);
      }
    }
    
  }
customElements.define("product-drawer", ProductDrawer);

  class templateProductJS {
    constructor() {
        if(selectors.reviewratingEle){
            selectors.reviewratingEle.addEventListener('click', (event)=>{
                event.preventDefault();
                const reviewSection = document.querySelector('#hulk__product-review');
                if(reviewSection) reviewSection.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
            });
        }

        selectors.zoomBtns.forEach((btn)=>{
            btn.addEventListener('click', (event)=>{
                let currentTarget = event.target;
                this.manageZoom(currentTarget);
            })
        });
    }


}

typeof templateProductJS !== 'undefined' && new templateProductJS();

